<template>
  <div class="qdSignContractDetail">
    <div class="header clear">
      <span class="fl_left">渠道签约详情页</span>
      <el-button class="fl_right" plain @click="onlineSignatureHandle">电子签章</el-button>
      <el-button class="fl_right" type="primary" @click="dialogVisible = true">线下签章</el-button>
    </div>
    <el-scrollbar>
      <div class="wrapper">
        <div class="danger">
          <span>操作说明：</span>
          <p>1.若使用纸质版合同，请先选择打印协议，线下盖章完成后选择.上传协议；</p>
          <p>2.若使用电子版协议，请选择电子签章，线上盖章完成后会自动开通权限；</p>
          <p>3.电子签章需要先确定是否已在官网维护好电子章。</p>
        </div>
        <div>
          <pdf
            :src="pdfUrl"
            v-for="i in numPages"
            :key="i"
            :page="i"
          />
        </div>
      </div>
    </el-scrollbar>
    <el-dialog
      title="线下签章"
      :visible.sync="dialogVisible"
      width="800px"
      class="contractDialog"
    >
      <div class="common_readonly_template">
        <el-row>
          <el-col :span="24">
            <div>
              <div class="label">下载协议</div>
              <div class="text"><span @click="contractDownload"><i class="iconfont icon-xiazai-Icon" />点击下载协议</span></div>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <div class="label">上传协议</div>
              <div class="text">
                <div>
                  <el-upload
                    class="upload"
                    :action="baseUrl"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                    :limit="1"
                    :file-list="fileList"
                    accept=".pdf,.PDF"
                  >
                    <div>
                      <el-button type="primary"><i class="iconfont icon-shangchuan-icon1" />点击上传</el-button>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { qdSignContractApi } from '@/API/home';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { channelAccountManagementApi } from '@/views/backStageManagement/service';
export default {
  components: {
    pdf
  },
  data () {
    return {
      numPages: 0,
      pdfUrl: '',
      dialogVisible: false,
      baseUrl: window._env_.VUE_APP_FILESERVICE_URL,
      fileList: []
    };
  },
  methods: {
    onlineSignatureHandle () {
      qdSignContractApi.signatureSubmit(this.$store.state.qdSignContractFileId).then(res => {
        if (res.status === '200') {
          window.open(res.data);
          setTimeout(() => {
            this.$confirm('是否签署完成', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/401');
            }).catch(() => {});
          }, 1000);
        }
      });
    },
    submitUpload () {
      if (this.fileList.length > 0) {
        let { qdSignContractFormInfo } = this.$store.state;
        if (!this.fileList[0].response.data[0].FID) {
          this.$message.error('协议上传失败，请删除重新上传');
          return;
        }
        let params = {
          secondParty: qdSignContractFormInfo.secondParty,
          lealPerson: qdSignContractFormInfo.juridicalPerson,
          contact: qdSignContractFormInfo.contacts,
          contactPhone: qdSignContractFormInfo.phone,
          contactEmail: qdSignContractFormInfo.email,
          address: qdSignContractFormInfo.address,
          bank: qdSignContractFormInfo.bank,
          bankAcountName: qdSignContractFormInfo.accountName,
          bankAcount: qdSignContractFormInfo.accountNumber,
          groupId: qdSignContractFormInfo.userId,
          groupName: qdSignContractFormInfo.userName,
          taxPayerCode: qdSignContractFormInfo.taxPayerCode,
          fileId: this.fileList[0].response.data[0].FID,
          fileName: this.fileList[0].response.data[0].FullName,
          stat: 3
        };
        channelAccountManagementApi.channelAccountUpdate(params).then(res => {
          if (res.status === '200') {
            this.$router.push('/401');
          }
        });
      }
    },
    handleSuccess (response, file, fileList) {
      if (response.status === '200') {
        this.fileList = fileList;
      } else {
        this.fileList.splice(this.fileList.length - 1);
        this.$message.error(response.err);
      }
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        const isPdf = file.type === 'application/pdf';
        if (!isPdf) {
          this.$message.error('上传协议只能是 JPG 格式!');
          reject(new Error('上传协议只能是 JPG 格式!'));
          return false;
        }
        if (!fileSize) {
          this.$message.error('上传的文件大小不能超过10M');
          reject(new Error('上传的文件大小不能超过10M'));
          return false;
        }
        newApplicationFormApi.getFileToken().then(res => {
          if (res.status === '200') {
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    beforeRemove (file, fileList) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    },
    contractDownload () {
      if (this.$store.state.qdSignContractFileId) {
        this.$store.commit('setSubPageLoading', true);
        this.getPdfUrl().then(res => {
          this.$store.commit('setSubPageLoading', false);
          if (res.status === '200') {
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = res.data;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
          }
        });
      }
    },
    getNumPages () {
      if (this.$store.state.qdSignContractFileId) {
        this.$store.commit('setSubPageLoading', true);
        this.getPdfUrl().then(res => {
          if (res.status === '200') {
            this.pdfUrl = pdf.createLoadingTask(res.data);
            this.pdfUrl.promise.then(pdf => {
              this.numPages = pdf.numPages;
            }).catch(err => {
              // console.log(err);
            });
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }
    },
    getPdfUrl () {
      if (this.$store.state.qdSignContractFileId) {
        return qdSignContractApi.getPdfUrl(this.$store.state.qdSignContractFileId);
      }
      return {};
    },
    async init () {
      let signingBeforeData = await this.getPdfUrl();
      let pdfUrl = signingBeforeData.status === '200' && signingBeforeData.data ? signingBeforeData.data : '';
      this.pdfUrl = pdf.createLoadingTask(pdfUrl);
      this.pdfUrl.promise.then(pdf => {
        this.numPages = pdf.numPages;
      }).catch(err => {
        // console.log(err);
      });
    }
  },
  mounted () {
    if (!this.$store.state.qdSignContractFileId) {
      this.$store.commit('setQdSignContractFileId', sessionStorage.getItem('qdSignContractFileId'));
    }
    if (!this.$store.state.qdSignContractFormInfo.userId && sessionStorage.getItem('qdSignContractFormInfo')) {
      this.$store.commit(
        'setQdSignContractFormInfo',
        JSON.parse(sessionStorage.getItem('qdSignContractFormInfo'))
      );
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('qdSignContractFileId', this.$store.state.qdSignContractFileId);
      sessionStorage.setItem(
        'qdSignContractFormInfo',
        JSON.stringify(this.$store.state.qdSignContractFormInfo)
      );
    });
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.qdSignContractDetail{
  width: 100%;
  height: 100%;
  >.header{
    width: 100%;
    padding: 13px 28px;
    line-height: 32px;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    color: #424C57;
    font-size: 16px;
    >span{
      cursor: pointer;
    }
    >.el-button{
      margin-left: 10px;
    }
  }
  > .el-scrollbar {
    width: 100%;
    height: 100%;
    margin-top: 58px;
    ::v-deep> .el-scrollbar__wrap {
      box-sizing: border-box;
      overflow-x: hidden;
      .wrapper {
        width: 1200px;
        padding: 20px 0;
        margin: 0 auto 50px;
        >.danger{
          color: #F53E48;
          line-height: 24px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .el-dialog{
    .common_readonly_template{
      .text>span{
        color: #508DB4;
        margin-left: 8px;
        cursor: pointer;
        >i{
          margin-right: 8px;
          font-size: 14px;
        }
      }
      .el-upload__tip{
        color: #5B646E;
        margin-left: 10px;
      }
    }
  }
}
</style>
